import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createPlatformOrganisation,
  CreatePlatformOrganisationRequest,
  CreatePlatformOrganisationResponse,
} from '../api/platformApi';
import { platformKeys } from './usePlatformOrganisations';

export function useCreatePlatformOrganisation() {
  const queryClient = useQueryClient();

  return useMutation<
    CreatePlatformOrganisationResponse,
    Error,
    CreatePlatformOrganisationRequest
  >({
    mutationFn: createPlatformOrganisation,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: platformKeys.all });
    },
  });
}
